package co.maytes.standupbot.dashboard.pages.app.templates

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.feedback.SkeletonBlock
import co.maytes.standupbot.dashboard.components.feedback.SkeletonCard
import co.maytes.standupbot.dashboard.components.feedback.SkeletonFormFields
import co.maytes.standupbot.dashboard.components.feedback.SkeletonLine
import co.maytes.standupbot.dashboard.components.layout.AdminGuard
import co.maytes.standupbot.dashboard.components.layout.AppShell
import co.maytes.standupbot.dashboard.components.layout.AuthGuard
import co.maytes.standupbot.dashboard.components.widgets.AppPageHeader
import co.maytes.standupbot.dashboard.features.templates.TemplateEditor
import co.maytes.standupbot.dashboard.features.templates.TemplateEditorMode
import co.maytes.standupbot.dashboard.features.templates.rememberTemplatesStore
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.dashboard.styles.Spacing
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.px

@Page("/app/templates/new")
@Composable
fun TemplatesNewPage() {
    AuthGuard {
        AdminGuard {
            AppShell {
                TemplatesNewContent()
            }
        }
    }
}

@Composable
private fun TemplatesNewContent() {
    val auth = rememberAuthStore()
    val ctx = rememberPageContext()
    val store = rememberTemplatesStore()
    val workspaceId = auth.currentUser?.workspace?.id
    val fromDefault = ctx.route.params["from"] == "default"

    Box(
        modifier = Modifier.fillMaxWidth()
            .styleModifier { property("margin", "0 auto") }
            .maxWidth(1200.px),
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppPageHeader(
                title = if (fromDefault) "Duplicate default" else "New template",
                eyebrow = "admin",
                subtitle = "Sections and headings apply to your posted standup. The prompt text is a preview only for now.",
            )
            Box(modifier = Modifier.margin(top = Spacing.md)) {
                if (workspaceId.isNullOrBlank()) {
                    Column(modifier = Modifier.fillMaxWidth().styleModifier { property("gap", "16px") }) {
                        SkeletonCard {
                            SkeletonFormFields(2)
                        }
                        SkeletonCard {
                            Column(modifier = Modifier.fillMaxWidth().styleModifier { property("gap", "12px") }) {
                                SkeletonLine(widthPct = 26, heightPx = 12)
                                SkeletonBlock(heightPx = 220, radiusPx = 10)
                            }
                        }
                    }
                } else {
                    TemplateEditor(
                        workspaceId = workspaceId,
                        mode = TemplateEditorMode.Create(seedFromDefault = fromDefault),
                        store = store,
                    )
                }
            }
        }
    }
}
